import { useHistory } from 'react-router-dom';
import { useCallback } from 'react';

/**
 * Custom hook for robust navigation that works with React Router v5
 * Provides fallback navigation methods if the router hook fails
 */
export const useNavigation = () => {
  const history = useHistory();

  const goBack = useCallback(() => {
    try {
      if (history && typeof history.back === 'function') {
        history.back();
        return;
      }

      if (window.history && window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = '/';
      }
    } catch (error) {
      console.error('Navigation error:', error);
      window.location.href = '/';
    }
  }, [history]);

  const goTo = useCallback(
    (path) => {
      try {
        if (history && typeof history.push === 'function') {
          history.push(path);
          return;
        }

        window.location.href = path;
      } catch (error) {
        console.error('Navigation error:', error);
        window.location.href = path;
      }
    },
    [history]
  );

  const replace = useCallback(
    (path) => {
      try {
        if (history && typeof history.replace === 'function') {
          history.replace(path);
          return;
        }

        window.location.replace(path);
      } catch (error) {
        console.error('Navigation error:', error);
        window.location.replace(path);
      }
    },
    [history]
  );

  return {
    goBack,
    goTo,
    replace,
    history,
  };
};
